import { Heading, Paragraph, Popover, TextButton } from '@zillow/constellation-10';
import { CONDITIONAL_APPROVAL_URL } from '../../constants/urls';

export function ConditionalApprovalPopper() {
  return (
    <Popover
      header={<Heading level={4}>Your application is still under review</Heading>}
      body={
        <>
          <Paragraph css={{ marginBottom: 'tight' }}>
            For your protection, local law requires landlords to conditionally approve applications before they can view
            the criminal history section of your background report.
          </Paragraph>
          <TextButton asChild>
            <a href={CONDITIONAL_APPROVAL_URL} target="_blank" rel="noopener noreferrer">
              Learn more
            </a>
          </TextButton>
        </>
      }
    />
  );
}
